import { SceneContext } from '@/lib/threeScene/SceneContext';
import { lpsPoint } from '@/domain/anatomy/LPS';
import { DirectionalLight, HemisphereLight, Scene } from 'three';
import { addObject } from '@/lib/threeScene/object3d';
import { addPlannerMaterials } from '@/views/3d-planner/scene/plannerMaterial';
import type { PlannerNode, PlannerSceneState } from '@/views/3d-planner/scene/plannerSceneState';

export class PlannerSceneContext extends SceneContext<PlannerNode, PlannerSceneState> {}

export function plannerSceneContext(state: PlannerSceneState): PlannerSceneContext {
    const scene = new Scene();
    scene.up.set(0, 0, 1);
    addStandardLights(scene);

    const sceneContext = new PlannerSceneContext(scene, state);
    addPlannerMaterials(sceneContext);

    return sceneContext;
}

const DIRECTIONAL_LIGHT_COLOR = '#ffffff';
const HEMI_LIGHT_SKY = '#ffffff';
const HEMI_LIGHT_GROUND = '#777a70';
const HEMI_LIGHT_POSITION = lpsPoint({ superior: 2000 });
type StandardLights = Readonly<{
    directional?: DirectionalLight;
    hemisphere: HemisphereLight;
}>;

function addStandardLights(scene: Scene): StandardLights {
    return {
        directional: addObject(scene, () => {
            const light = new DirectionalLight(DIRECTIONAL_LIGHT_COLOR);
            light.intensity = 1;
            light.position.set(0, 0, 1000);
            light.updateMatrix();
            return light;
        }),
        hemisphere: addObject(scene, () => {
            const light = new HemisphereLight(HEMI_LIGHT_SKY, HEMI_LIGHT_GROUND, 5);
            light.position.copy(HEMI_LIGHT_POSITION);
            light.updateMatrix();
            return light;
        }),
    };
}
